/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./logo-p.vue?vue&type=template&id=568d0bc2&scoped=true&"
import script from "./logo-p.vue?vue&type=script&lang=ts&"
export * from "./logo-p.vue?vue&type=script&lang=ts&"
import style0 from "./logo-p.vue?vue&type=style&index=0&id=568d0bc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d0bc2",
  null
  
)

export default component.exports